document.addEventListener("DOMContentLoaded", () => {
  class GPOManager {
    constructor() {
      this.state = { wired: false };

      this.selectors = {
        gpoContainer: ".gpo-container",
        gpoGroup: ".gpo-group",
        gpoElement: ".gpo-element",
        toggle: "#gpo-toggle",
        toggleLabel: "#gpo-toggle-label",
        wrapper: "#gpo-question-container",
        infoBox: ".custom-bag-info",
      };

      this.observe();
    }

    observe() {
      this.observer = new MutationObserver(() => this.onMutation());
      this.observer.observe(document.body, { childList: true, subtree: true });
    }

    onMutation() {
      const gpoContainer = document.querySelector(this.selectors.gpoContainer);
      if (!gpoContainer) return;

      this.bootstrapOnce(gpoContainer);
      this.appendTotalBlock(gpoContainer);
      this.syncGpoVisibility(gpoContainer);
      requestAnimationFrame(() => this.syncShippingBlock(gpoContainer));
      this.moveHideRequestHelpText();
      this.removeWidthParams();
    }

    bootstrapOnce(gpoContainer) {
      if (this.state.wired) return;

      const wrapper = document.querySelector(this.selectors.wrapper);
      
      if (wrapper && gpoContainer) {
        wrapper.classList.add("is-visible");
        this.state.wired = true; 
      } else {
        return; 
      }

      document
        .querySelectorAll(this.selectors.gpoGroup)
        .forEach((group) => this.wrapLabels(group));

      this.handleToggle(gpoContainer);
      this.handleWrapperVisibility(gpoContainer);
    }

    // syncGpoVisibility(gpoContainer) {
    //   const toggle = document.querySelector(this.selectors.toggle);
    //   if (!toggle) return;

    //   gpoContainer.classList.toggle("hide-gpo-fields", !toggle.checked);
    // }
syncGpoVisibility(gpoContainer) {
  const btn = document.querySelector("#gpo-toggle-btn");
  if (!btn) return;

  const isActive = btn.getAttribute("aria-pressed") === "true";
  gpoContainer.classList.toggle("hide-gpo-fields", !isActive);
}

syncShippingBlock(gpoContainer) {
  let saleBlock = gpoContainer.querySelector(".gfg-sale-block");
  let shipping = gpoContainer.querySelector(".icon-with-text.icon-with-text--vertical.list-unstyled");

  // --- Shipping Block Sync ---
  if (!shipping) {
    const original = document.querySelector(".icon-with-text.icon-with-text--vertical.list-unstyled");
    if (original) {
      shipping = original.cloneNode(true);
      gpoContainer.appendChild(shipping);
    } else {
      return;
    }
  }

  // --- Sale Block Sync ---
  if (!saleBlock) {
    const original = document.querySelector(".gfg-sale-block");
    if (original) {
      saleBlock = original.cloneNode(true);
      gpoContainer.appendChild(saleBlock);

      this.startTimer(saleBlock);
    } else {
      return;
    }
  }

  // --- Positioning Logic ---
  const totalWrapper = gpoContainer.querySelector(".gpo-total-wrapper");
  
  if (totalWrapper) {
    if (shipping.nextElementSibling !== totalWrapper) {
      gpoContainer.insertBefore(shipping, totalWrapper);
    }
    if (saleBlock.previousElementSibling !== totalWrapper) {
      totalWrapper.insertAdjacentElement('afterend', saleBlock);
    }
  }
}


    startTimer(container) {
      const endDate = container.getAttribute('data-end-date');
      const endTime = container.getAttribute('data-end-time');
      if (!endDate || !endTime) return;

      const endTimestamp = new Date(`${endDate} ${endTime}:00`).getTime();
      const pad = n => String(n).padStart(2, '0');

      // ID ke bajaye classes se target karein taake clone par masla na ho
      const dNode = container.querySelector('.gfg-num#gfg-days') || container.querySelector('.gfg-days-class');
      const hNode = container.querySelector('.gfg-num#gfg-hours');
      const mNode = container.querySelector('.gfg-num#gfg-mins');
      const sNode = container.querySelector('.gfg-num#gfg-secs');

      const tick = setInterval(() => {
        const remaining = endTimestamp - Date.now();

        if (remaining <= 0) {
          clearInterval(tick);
          container.style.display = 'none';
          return;
        }

        const d = Math.floor(remaining / 86400000);
        const h = Math.floor((remaining % 86400000) / 3600000);
        const m = Math.floor((remaining % 3600000) / 60000);
        const s = Math.floor((remaining % 60000) / 1000);

        if (dNode) dNode.textContent = pad(d);
        if (hNode) hNode.textContent = pad(h);
        if (mNode) mNode.textContent = pad(m);
        if (sNode) sNode.textContent = pad(s);
      }, 1000);
    }

    wrapLabels(container) {
      container.querySelectorAll(".gpo-ov-item label").forEach((label) => {
        const thumbnail = label.querySelector(".dropdown-item__thumbnail");
        if (!thumbnail) return;

        const img = thumbnail.querySelector("img");
        if (img && img.src.includes("?width=")) {
          img.src = img.src.split("?width=")[0];
        }

        const nodes = [...label.childNodes].filter(
          (n) => n !== thumbnail && (n.nodeType === 1 || n.nodeType === 3),
        );

        if (!nodes.length || label.querySelector(".wrapped-text")) return;

        const span = document.createElement("span");
        span.className = "wrapped-text";
        nodes.forEach((n) => span.appendChild(n));
        thumbnail.after(span);
      });
    }

    appendTotalBlock(gpoContainer) {
      if (gpoContainer.querySelector(".gpo-total-wrapper")) return;

      const wrapper = document.createElement("div");
      wrapper.className = "gpo-total-wrapper";
      wrapper.style.cssText = `
        margin-top:10px;
        font-weight:bold;
        font-size:16px;
        line-height:1;
        display:flex;
        gap:1rem;
        align-items:center;
      `;

      const label = document.createElement("div");
      label.textContent = "TOTAL:";

      const total = document.createElement("div");
      total.setAttribute("data-gpo-product-unit-price", "");

      wrapper.append(label, total);

      gpoContainer.append(wrapper);
    }

    // handleToggle(gpoContainer) {
    //   const btn = document.querySelector("#gpo-toggle-btn");
    //   const infoBox = document.querySelector(this.selectors.infoBox);

    //   if (!btn) return;

    //   btn.addEventListener("click", () => {
    //     const isActive = btn.getAttribute("aria-pressed") === "true";
    //     const nowActive = !isActive;

    //     btn.setAttribute("aria-pressed", String(nowActive));
    //     btn.querySelector(".gpo-btn-text").textContent = nowActive
    //       ? "Close"
    //       : "Click Here";

    //     gpoContainer.classList.toggle("hide-gpo-fields", !nowActive);
    //     infoBox?.classList.toggle("hidden-customization-bag", !nowActive);
    //   });
    // }
handleToggle(gpoContainer) {
  const btn = document.querySelector("#gpo-toggle-btn");
  const infoBox = document.querySelector(this.selectors.infoBox);

  if (!btn) return;

  btn.addEventListener("click", () => {
    const isActive = btn.getAttribute("aria-pressed") === "true";
    const nowActive = !isActive;

    btn.setAttribute("aria-pressed", String(nowActive));
    btn.querySelector(".gpo-btn-text").textContent = nowActive ? "Close" : "Click Here";

    gpoContainer.classList.toggle("hide-gpo-fields", !nowActive);
    infoBox?.classList.toggle("hidden-customization-bag", !nowActive);
  });
}

    moveHideRequestHelpText() {
      document.querySelectorAll(this.selectors.gpoElement).forEach((group) => {
        const button = group.querySelector(".dropdown-button__value");
        const help = group.querySelector(".gpo-helptext");
        const list = group.querySelector(".dropdown-list");

        if (!button || !help || !list) return;

        const text = button.textContent.toLowerCase();
        if (text.includes("hide request") && !list.contains(help)) {
          list.appendChild(help);
        }
      });
    }

    removeWidthParams() {
      document.querySelectorAll(".swatch-image").forEach((img) => {
        if (!img.src) return;
        const url = new URL(img.src);
        url.searchParams.delete("width");
        img.src = url.toString();
      });
    }

    handleWrapperVisibility() {
      const wrapper = document.querySelector(this.selectors.wrapper);
      const infoBox = document.querySelector(this.selectors.infoBox);
      const toggle = document.querySelector(this.selectors.toggle);

      if (!wrapper) return;

      wrapper.classList.remove("hidden-customization-bag");

      const info_box_text = window.ThemeSettings.customizationText;

      if (infoBox && !infoBox.innerHTML.trim()) {
        infoBox.innerHTML =
          `<span>${info_box_text}</span>`;
      }

      if (infoBox && toggle) {
        infoBox.classList.toggle("hidden-customization-bag", !toggle.checked);
      }
    }
  }

  new GPOManager();
});
